import { render } from "./ProfesionalesListadoCA.vue?vue&type=template&id=0f838e77&ts=true"
import script from "./ProfesionalesListadoCA.vue?vue&type=script&lang=ts"
export * from "./ProfesionalesListadoCA.vue?vue&type=script&lang=ts"

import "./ProfesionalesListadoCA.vue?vue&type=style&index=0&id=0f838e77&lang=scss"

import exportComponent from "/opt/build/repo/front-panel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__